import { CeleryStatusesMapIdType } from "@shared/constants";
import Repository from "../api/abstracts/Repository";

export type CeleryJobSerializer = {
  id: string;
  data: string;
  state: CeleryStatusesMapIdType;
};

export default class CeleryJobRepository extends Repository<CeleryJobSerializer> {
  public readonly repositoryName = "CeleryJobRepository";

  public readonly endpoint = `/api/celery/`;
}
